<template>
  <div>
    <v-container fluid pt-0 grid-list-xl v-if="tempReport">
      <section-tooltip
        :title="tempReport.settings.caption[$i18n.locale]"
        :tooltip="tempReport.settings.description[$i18n.locale]"
      ></section-tooltip>
      <app-card customClasses="mb-30 inherit-overflow">
        <div v-if="!!tempReport.settings.isExcelExportEnabled">
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              fab
              dark
              color="blue"
              @click="$refs.grid.instance.exportToExcel(false)"
              small
              absolute
              top
              right
            >
              <v-icon dark>grid_on</v-icon>
            </v-btn>
            <span>Excel export</span>
          </v-tooltip>
          <br />
        </div>
        <div class="gptReport--viewport" v-bind:style="{ width: tableWidth }">
          <dx-pivot-grid
            ref="grid"
            :data-source="dataSource"
            :allow-sorting-by-summary="true"
            :allow-sorting="true"
            :allow-filtering="true"
            :show-borders="tempReport.settings.showBorders"
            :show-column-grand-totals="tempReport.settings.showColumnGrandTotals"
            :show-row-grand-totals="tempReport.settings.showRowGrandTotals"
            :show-row-totals="tempReport.settings.showRowTotals"
            :show-column-totals="tempReport.settings.showColumnTotals"
            :rtl-enabled="tempReport.settings.rtlEnabled"
            :rowHeaderLayout="!!tempReport.settings.showRowHeaderAsTree ? 'tree' : 'standard'"
            :state-storing="stateStoring"
            @cellPrepared="onCellPrepared"
            @contentReady="onContentReady"
          >
            <dx-field-chooser :enabled="tempReport.settings.isFieldChooserEnabled" />
            <dx-export :file-name="tempReport.settings.excelExportFileName" />
            <dx-field-panel
              :enabled="true"
              :visible="tempReport.settings.isFieldPanelVisible"
              :show-data-fields="false"
              :show-row-fields="true"
              :show-column-fields="true"
              :show-filter-fields="false"
            />
          </dx-pivot-grid>
        </div>
      </app-card>
    </v-container>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import fields from '@/helpers/report-fields.js';
import reportMixin from '@/lib/mixins/report.js';

export default {
    mixins: [reportMixin],
    data() {
        return {
            tableWidth: '100%',
            tempReport: null
        };
    },
    computed: {
        ...mapGetters(['report', 'reportingData']),
        stateStoring: function() {
            const self = this;
            return {
                enabled: true,
                savingTimeout: 100,
                type: 'custom',
                customLoad: () => {
                    return {
                        columnExpandedPaths: self.tempReport.columnExpandedPaths,
                        fields: self.tempReport.fields,
                        rowExpandedPaths: self.tempReport.rowExpandedPaths
                    };
                }
            };
        }
    },
    watch: {
        $route(to, from) {
            if (this.$route.params.id) {
                this.$store.dispatch('getReport', {
                    _id: this.$route.params.id
                });
            }
        }
    },
    created() {
        if (this.$route.params.id) {
            this.$store.dispatch('getReport', { _id: this.$route.params.id });
        }
    },
    methods: {
        // The pivot grid resizes columns at will, we therefore force the
        // columns to use a common width here.
        // @see https://www.devexpress.com/Support/Center/Question/Details/T325911/how-to-change-the-width-of-the-dxpivotgrid-summary-field
        onCellPrepared({ area, cell, cell: { colspan = 1, isWhiteSpace, path = [] }, cellElement }) {
            const { showRowHeaderAsTree } = this.tempReport.settings;
            let width;
            if (area === 'row') {
                if (!showRowHeaderAsTree || isWhiteSpace) {
                    return;
                } else {
                    width = 200 - (path.length - 1) * 20;
                }
            } else {
                width = 120;
            }

            cellElement.style.minWidth = `${width}px`;
            cellElement.style.maxWidth = `${width}px`;
        },

        // Avoid extra wide columns if there are not enough columns to fill
        // the viewport width.
        // @see https://www.devexpress.com/Support/Center/Question/Details/T406912/dxpivotgrid-how-to-change-width-at-runtime
        onContentReady({ component }) {
            const element = component.element();
            const cols = element.querySelectorAll('.dx-area-data-cell colgroup col');
            const dataHeader = element.querySelector('.dx-data-header');

            const tableWidth = cols.length
                ? `${(dataHeader ? dataHeader.offsetWidth : 256) + cols.length * 150}px`
                : '100%';

            if (this.tableWidth !== tableWidth) {
                this.tableWidth = tableWidth;
                this.$nextTick(() => component.repaint());
            }
        }
    }
};
</script>

<style lang="scss">

</style>